import { vservice } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { ExportExcelResourceType } from '@/modules/common/table-export/models/export-resource.model'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'

@vservice()
export class ExportRequestUseCase {

  public remoteData = RemoteData
    .notAsked<ExportExcelResourceType | { url: string }>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get data(): ExportExcelResourceType | { url: string } {
    return this.remoteData.fold(
      () => null,
      value => value || null,
      value => value,
      (error, value) => value || null
    )
  }

  execute(exportRoute: string): RemoteData<ExportExcelResourceType | { url: string }> {
    return this.remoteData.fromPromise(
      HTTP.get(exportRoute).then((result) => {
        return result.json()
      })
    )
  }
}
